import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate();
    
    return (
            <div className='row-home'>
                <button className='boton-extra' onClick={() => navigate('/bienvenidos')}>Bienvenidos</button>
                <div className='columna-home' style={{  gap: '10px' }}>
                    <button className='boton-extra' onClick={() => navigate('/felicidades')}>Felicidades</button>
                    <button className='boton-extra' onClick={() => navigate('/agregarFelicidades')}>Agregar Felicidades</button>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '20px' }}>
                    <div className='columna-home'>
                        <button className='boton-mandar' onClick={() => navigate('/salto')}>Salto</button>
                        <button className='boton-mandar' onClick={() => navigate('/barra')}>Barra</button>
                        <button className='boton-mandar' onClick={() => navigate('/viga')}>Viga</button>
                        <button className='boton-mandar' onClick={() => navigate('/piso')}>Piso</button>
                        <button className='boton-mandar' onClick={() => navigate('/puntaje')}>Agregar puntaje</button>
                    </div>
                    <div className='columna-home'>
                        <button className='boton-mandar2' onClick={() => navigate('/resultados')}>Resultados</button>
                        <button className='boton-mandar2' onClick={() => navigate('/resultadosSalto')}>Resultados Salto</button>
                        <button className='boton-mandar2' onClick={() => navigate('/resultadosBarra')}>Resultados Barra</button>
                        <button className='boton-mandar2' onClick={() => navigate('/resultadosViga')}>Resultados Viga</button>
                        <button className='boton-mandar2' onClick={() => navigate('/resultadosPiso')}>Resultados Piso</button>
                        <button className='boton-mandar2' onClick={() => navigate('/resultadosAA')}>Resultados AA</button>
                    </div>
                </div>
            </div>
    );
};

export default Home;
